import { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../Config';

interface ImageContent {
  image?: string;
}

export const useImages = (webContentID?: string): ImageContent => {
  const [contents, setContents] = useState<ImageContent>({});

  useEffect(() => {
    if (!webContentID) {
      setContents({});
      return;
    }
    const fetchData = async (): Promise<void> => {
      try {
        const res = await axios.get<string>(`${config.apiUrl}/Image/6/tenant/${webContentID}`);
        setContents({
          image: res.data
        });
      } catch (error) {
        console.error('Error fetching Images:', error);
      }
    };

    fetchData();
  }, [webContentID]);

  return contents;
};